import React, { useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiButton } from 'src/components/UI/Button';
import { SidebarModelResponse } from 'src/models/Partner/Sidebar';
import { useRefClickOutside } from 'src/utils/hooks/useRefClickOutside';
import { IconClose } from './icons';
import styles from './styles.module.scss';
import sidebarStyles from '../../styles.module.scss';

type SidebarOrganizationsType = {
  items: SidebarModelResponse['OrganizerOrganizations'];
  onClose: () => void;
  onChangeCurrentOrganization: (orgUrl: string) => void;
};

export const OrganizationsList: React.FC<SidebarOrganizationsType> = ({
  items,
  onClose,
  onChangeCurrentOrganization,
}: SidebarOrganizationsType) => {
  const ref = useRefClickOutside<HTMLDivElement>(true, onClose, 10);

  const { t } = useTranslation();

  const [show, setShow] = useState(true);

  const closeListWithAnimation = () => setShow(false);

  return (
    <>
      <div role="presentation" className={classNames(styles.backdrop)} onClick={closeListWithAnimation} />

      <div
        className={classNames(styles.organizationList, sidebarStyles.organizationList, {
          [styles.opened]: show,
          [styles.closed]: !show,
        })}
        ref={ref}
      >
        <div
          className={styles.inner}
          onAnimationEnd={() => {
            if (!show) {
              onClose();
            }
          }}
        >
          <div className={styles.header}>
            {t('leftMenu.switchOrganization')}&nbsp;
            <IconClose onClick={closeListWithAnimation} className={styles.headerIcon} />
          </div>

          <hr className={styles.divider} />

          {items.map((org) => (
            <UiButton
              key={org.Name}
              tag="a"
              className={classNames(styles.item, org.IsCurrentOrganization && styles.selected)}
              disabled={org.IsCurrentOrganization}
              onClick={() => {
                onClose();
                onChangeCurrentOrganization(org.Url);
              }}
              title={org.Name}
            >
              {org.Name}
            </UiButton>
          ))}
        </div>
      </div>
    </>
  );
};
